export const featuredBrands = [
  {
    name: 'Chanel',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20luxury%20brand%20logo%20design%20concept%2C%20elegant%20interlocking%20letters%20on%20cream%20background%2C%20sophisticated%20fashion%20brand%20identity%2C%20clean%20typography%2C%20warm%20neutral%20tones&width=200&height=120&seq=brand-logo-01&orientation=landscape',
    description: '法国奢侈品牌，以高级定制、香水及配饰闻名于世',
    articleCount: 24,
  },
  {
    name: 'Gucci',
    logo: 'https://readdy.ai/api/search-image?query=Elegant%20Italian%20brand%20logo%20concept%20with%20sophisticated%20typography%2C%20minimalist%20design%20on%20cream%20background%2C%20luxury%20fashion%20identity%2C%20warm%20neutral%20aesthetic&width=200&height=120&seq=brand-logo-02&orientation=landscape',
    description: '意大利奢侈品牌，以其独特设计和大胆创新著称',
    articleCount: 19,
  },
  {
    name: 'Apple',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20tech%20brand%20logo%20concept%20with%20simple%20fruit%20silhouette%20on%20cream%20background%2C%20clean%20modern%20identity%2C%20sophisticated%20design%2C%20warm%20neutral%20tones&width=200&height=120&seq=brand-logo-03&orientation=landscape',
    description: '美国科技巨头，以创新设计和生态系统引领行业',
    articleCount: 15,
  },
  {
    name: 'Hermès',
    logo: 'https://readdy.ai/api/search-image?query=Elegant%20French%20luxury%20brand%20logo%20concept%20with%20horse%20carriage%20motif%20on%20cream%20background%2C%20sophisticated%20heritage%20identity%2C%20warm%20neutral%20aesthetic&width=200&height=120&seq=brand-logo-04&orientation=landscape',
    description: '法国顶级奢侈品牌，以皮具、丝巾及工匠精神享誉全球',
    articleCount: 12,
  },
  {
    name: 'Nike',
    logo: 'https://readdy.ai/api/search-image?query=Dynamic%20sportswear%20brand%20logo%20concept%20with%20swoosh%20design%20on%20cream%20background%2C%20clean%20modern%20athletic%20identity%2C%20warm%20neutral%20aesthetic&width=200&height=120&seq=brand-logo-05&orientation=landscape',
    description: '美国运动品牌巨头，Just Do It精神影响全球',
    articleCount: 18,
  },
  {
    name: 'Spotify',
    logo: 'https://readdy.ai/api/search-image?query=Modern%20music%20streaming%20brand%20logo%20concept%20with%20sound%20wave%20motif%20on%20cream%20background%2C%20clean%20digital%20identity%2C%20warm%20neutral%20aesthetic&width=200&height=120&seq=brand-logo-06&orientation=landscape',
    description: '瑞典音乐流媒体平台，重新定义了全球音乐消费方式',
    articleCount: 10,
  },
];